/**
 * ParLinx hero slideshow — the photos auto-crossfade on a hold timer; the
 * arrows step it manually and re-arm the timer rather than killing it.
 * Classic IIFE (no ES modules on the storefront).
 */
(function () {
  'use strict';

  var hero = document.querySelector('[data-plx-hero-slides]');
  if (!hero) return;
  var slides = hero.querySelectorAll('.plx-hero__slide-wrap');
  if (!slides.length) return;

  hero.classList.add('is-js');
  var index = 0;

  /* Hold is set per-section in the editor; the CSS owns the 600ms crossfade,
     so a full cycle is hold + fade. */
  var hold = parseInt(hero.getAttribute('data-hold'), 10);
  if (!hold || hold < 250) hold = 3000;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timer = null;
  var hovered = false;
  var onscreen = true;

  function show(i) {
    index = (i + slides.length) % slides.length;
    for (var n = 0; n < slides.length; n++) {
      slides[n].classList.toggle('is-active', n === index);
    }
  }

  function stop() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  /* setTimeout chain, not setInterval: an arrow click restarts the full hold
     instead of landing mid-interval. */
  function start() {
    stop();
    if (reduced || slides.length < 2) return;
    if (hovered || !onscreen || document.hidden) return;
    timer = setTimeout(function () {
      show(index + 1);
      start();
    }, hold);
  }

  var prev = hero.querySelector('[data-plx-hero-prev]');
  var next = hero.querySelector('[data-plx-hero-next]');
  if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
  if (next) next.addEventListener('click', function () { show(index + 1); start(); });

  /* Hold while the visitor is on the hero, reading it or tabbing the arrows. */
  hero.addEventListener('mouseenter', function () { hovered = true; stop(); });
  hero.addEventListener('mouseleave', function () { hovered = false; start(); });
  hero.addEventListener('focusin', function () { hovered = true; stop(); });
  hero.addEventListener('focusout', function () { hovered = false; start(); });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  /* Don't burn cycles crossfading a hero that's scrolled off. */
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      onscreen = entries[0].isIntersecting;
      if (onscreen) start(); else stop();
    }, { threshold: 0 }).observe(hero);
  }

  /* Three slides on a ~2.6s cycle: every photo is needed within a few seconds,
     so decode them all up front rather than chasing the fade. */
  var imgs = hero.querySelectorAll('.plx-hero__slide-wrap img');
  for (var k = 0; k < imgs.length; k++) imgs[k].loading = 'eager';

  show(0);
  start();
})();
